import { render, staticRenderFns } from "./SecurePayments.vue?vue&type=template&id=4404a497"
import script from "./SecurePayments.vue?vue&type=script&lang=js"
export * from "./SecurePayments.vue?vue&type=script&lang=js"
import style0 from "./SecurePayments.vue?vue&type=style&index=0&id=4404a497&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports